export const NETWORK: any  = process.env.REACT_APP_NETWORK;
export const API_BASE_URL: string | undefined = process.env.REACT_APP_API_BASE_URL;
export const BASE_URL : string | undefined = process.env.REACT_APP_BASE_URL;
export const HEDERA_NODE: string | undefined = process.env.REACT_APP_HEDERA_NODE;
export const TOKEN_API: string | undefined = process.env.REACT_APP_TOKEN_API;